import Factory from './utils/factory'

export default Factory({
  amount: null,
  phone: null,
  name: null,
  bank: null,
  email: null,
})
